import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface IntegrationTopicIconProps {
  integrationTopicIconUrl: string;
}

/*
 * Style.
 */

interface IconStyleProps {
  $iconUrl: string;
}

const StyledIconDiv = styled.div<IconStyleProps>`
  width: inherit;
  height: inherit;
  background-image: ${(p) => `url(${p.$iconUrl})`};
  background-size: contain;
  background-position: center;
`;

/*
 * Component.
 */

export const IntegrationTopicIcon: FC<IntegrationTopicIconProps> = ({integrationTopicIconUrl}) => (
  <StyledIconDiv $iconUrl={integrationTopicIconUrl} />
);
